import React from 'react';

import "./MoreButton.css";
import MoreUserButton from './User';
import MoreOrderButton from './Order';
import MoreConfigurationsButton from './Configurations';
import MoreGrabFoodConfigurationsButton from './GrabFoodConfigurations';
import MoreFoodPandaConfigurationsButton from './FoodPandaConfigurations';
import MoreSpotManagementButton from './SpotManagement';
import MoreEberButton from './Eber';
import MoreOpenApiButton from './OpenApi';

class MoreButton extends React.PureComponent {
    render () {
        switch(this.props.classes) {
            case "User":
                return (
                    <MoreUserButton {...this.props}></MoreUserButton>
                );
            case "paymentMerchant2":
                return (
                    <MoreOrderButton {...this.props} controllerKey={`controllerId`} createOrderKey={`customOrderId`}></MoreOrderButton>
                );
            case "GPayOrders":
                return (
                    <MoreOrderButton {...this.props} controllerKey={`restaurent_id`} createOrderKey={`partnerOrderId`}></MoreOrderButton>
                );
            case "GrabFoodOrders":
                return (
                    <MoreOrderButton {...this.props} controllerKey={`restaurant`} createOrderKey={`grabfoodOrderId`}></MoreOrderButton>
                );
            case "userPlanDevice":
                return (
                    <React.Fragment>
                        <MoreConfigurationsButton {...this.props}></MoreConfigurationsButton>
                        <MoreEberButton {...this.props}></MoreEberButton>
                        <MoreOpenApiButton {...this.props}></MoreOpenApiButton>
                    </React.Fragment>
                );
            case "GrabFoodRestaurant":
                return (
                    <MoreGrabFoodConfigurationsButton {...this.props}></MoreGrabFoodConfigurationsButton>
                );
            case "DeliveryHeroRestaurant":
                return (
                    <MoreFoodPandaConfigurationsButton {...this.props}></MoreFoodPandaConfigurationsButton>
                );
            case "SpotRestaurant":
                return (
                    <MoreSpotManagementButton {...this.props}></MoreSpotManagementButton>
                );
            default: 
                return null
        }
    }
}

export default MoreButton;